export type BundleRow = {
  id: string;
  slug: string;
  title_he: string;
  subtitle_he: string | null;
  tagline_he: string | null;
  description_he: string | null;
  price_ils: number | null;
  compare_at_ils: number | null;
  discount_pct: number | null;
  image_url: string | null;
  video_url: string | null;
  product_handles: string[];
  category: string | null;
  position: number;
  is_active: boolean;
  discount_code: string | null;
};

// Normalized view used by Shop bundle card
export type BundleView = {
  id: string;
  slug: string;
  name: string;
  sub: string;
  tagline: string;
  description: string;
  productIds: string[];
  discount: number;
  priceOverride?: number;
  compareAtOverride?: number;
  image?: string;
  video?: string;
  category?: string;
  discountCode?: string;
};

export function rowToView(r: BundleRow): BundleView {
  return {
    id: r.slug,
    slug: r.slug,
    name: r.title_he,
    sub: r.subtitle_he ?? '',
    tagline: r.tagline_he ?? '',
    description: r.description_he ?? '',
    productIds: r.product_handles ?? [],
    discount: (r.discount_pct ?? 0) / 100,
    priceOverride: r.price_ils ?? undefined,
    compareAtOverride: r.compare_at_ils ?? undefined,
    image: r.image_url ?? undefined,
    video: r.video_url ?? undefined,
    category: r.category ?? undefined,
    discountCode: r.discount_code ?? undefined,
  };
}
